import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { AppPaths } from '@ftr/routing-paths'
import { makePublicFeatureFlagGuard, NotFoundComponent, RedirectGlobalAdmin } from '@ftr/ui-core'
import { HelpPageModule } from '@ftr/ui-help'
import { RedirectToLiveStreamRecording } from '@ftr/ui-realtime-playback'
import {
  AuthenticationGuard,
  MultifactorAuthenticationPagesModule,
  PasswordResetPagesModule,
  SignupPagesModule,
} from '@ftr/ui-user'
import { RootModule } from './pages/root.module'

@NgModule({
  imports: [
    NotFoundComponent,
    RootModule,
    SignupPagesModule,
    PasswordResetPagesModule,
    HelpPageModule,
    MultifactorAuthenticationPagesModule,
    RouterModule.forRoot(
      [
        {
          path: AppPaths.DefaultPage,
          data: {
            breadcrumb: 'Home',
            title: 'Home',
          },
          children: [
            {
              path: AppPaths.DefaultPage,
              loadChildren: () => import('./pages/home/home-page.module').then(m => m.HomePageModule),
            },
            {
              path: `${AppPaths.Admin}/${AppPaths.CourtSystems}/:courtSystemId`,
              canActivate: [AuthenticationGuard, RedirectGlobalAdmin],
              component: NotFoundComponent, // Dummy Component, guard will always redirect
            },
            {
              path: `${AppPaths.Admin}/livestream`,
              canActivate: [AuthenticationGuard],
              component: RedirectToLiveStreamRecording, // Redirects to a currently live stream recording (particularly useful for local dev)
            },
            {
              path: AppPaths.Admin,
              canActivate: [AuthenticationGuard, RedirectGlobalAdmin],
              component: NotFoundComponent, // Dummy Component, guard will always redirect
              children: [
                {
                  path: '**',
                  component: NotFoundComponent, // Dummy Component, guard will always redirect
                },
              ],
            },
            {
              path: AppPaths.CourtSystem,
              canActivate: [AuthenticationGuard],
              loadChildren: () =>
                import('./pages/court-system/court-system-pages.module').then(m => m.CourtSystemPagesModule),
            },
            {
              path: AppPaths.CourtSystems,
              canActivate: [AuthenticationGuard],
              loadChildren: () =>
                import('./pages/court-system/court-system-pages.module').then(m => m.CourtSystemPagesModule),
            },
            {
              path: AppPaths.Jobs,
              canActivate: [AuthenticationGuard],
              loadChildren: () => import('./pages/jobs/jobs-pages.module').then(m => m.JobsPagesModule),
            },
            {
              path: AppPaths.Orders,
              canActivate: [AuthenticationGuard],
              loadChildren: () => import('./pages/orders/orders-pages.module').then(m => m.OrdersPagesModule),
            },
            {
              path: AppPaths.SharedWithMe,
              canActivate: [AuthenticationGuard],
              loadChildren: () =>
                import('./pages/shared-with-me/shared-with-me-pages.module').then(m => m.SharedWithMePagesModule),
            },
            {
              path: AppPaths.Account,
              canActivate: [AuthenticationGuard],
              loadChildren: () => import('./pages/account/account.module').then(m => m.AccountModule),
            },
            {
              path: AppPaths.AuditLog,
              canActivate: [AuthenticationGuard],
              loadChildren: () =>
                import('./pages/my-audit-log/my-audit-log-pages.module').then(m => m.MyAuditLogPagesModule),
            },
            {
              path: AppPaths.Transcripts,
              canActivate: [AuthenticationGuard],
              loadChildren: () =>
                import('./pages/transcripts/transcripts-page.module').then(m => m.TranscriptsPageModule),
            },
            {
              path: AppPaths.SharedRecordings,
              canActivate: [AuthenticationGuard],
              loadChildren: () =>
                import('./pages/shared-recordings/shared-recordings-pages.module').then(
                  m => m.SharedRecordingsPagesModule,
                ),
            },
            {
              path: AppPaths.Access,
              canActivate: [AuthenticationGuard, makePublicFeatureFlagGuard('public-navigation')],
              loadChildren: () => import('./pages/access/access-pages.module').then(m => m.AccessPagesModule),
            },
          ],
        },
        {
          path: '**',
          component: NotFoundComponent,
          canActivate: [AuthenticationGuard],
        },
      ],
      {
        canceledNavigationResolution: 'computed',
      },
    ),
    RootModule,
    SignupPagesModule,
    PasswordResetPagesModule,
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
